<div mat-dialog-title>
  <h2>{{'error_reporting.title' | translate}}</h2>
  <button class="close"
    data-e2e="error-reporting-modal-close"
    (click)="dialogRef.close()"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (reportingForm !== undefined) {
    <form [formGroup]="reportingForm">
      <mat-card-subtitle>
        {{'error_reporting.home_text' | translate}}
      </mat-card-subtitle>
      <mat-form-field>
        <mat-label>
          {{'error_reporting.mail_label' | translate}}
        </mat-label>
        <input matInput type="text" formControlName="mail">
      </mat-form-field>
      <mat-form-field>
        <mat-label>
          {{'error_reporting.subject_label' | translate}}
        </mat-label>
        <input matInput type="text" formControlName="subject">
      </mat-form-field>
      @if (reportingForm.get('objectTitle')) {
        <mat-form-field>
          <mat-label>
            {{'error_reporting.object_title' | translate}}
          </mat-label>
          <input matInput type="text" formControlName="objectTitle">
        </mat-form-field>
      }
      <mat-form-field>
        <mat-label>
          {{'error_reporting.comment_label' | translate}}
        </mat-label>
        <textarea matInput formControlName="message"></textarea>
      </mat-form-field>
    </form>
  }

  @if (isFormOnError) {
    <div class="message-box error">
      {{'error_reporting.error' | translate}}
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <!--    <button (click)="" mat-raised-button class="mat-accent">Envoyer</button>-->
  @if (isFormPending === false) {
    <button (click)="submitForm()" data-e2e="error-reporting-modal-submit" mat-raised-button class="mat-accent" [disabled]="reportingForm.valid === false || isFormOnError === true">
      {{'error_reporting.submit' | translate}}
    </button>
  } @else {
    <button mat-raised-button class="mat-accent" data-e2e="error-reporting-modal-submit-pending" disabled>
      <mat-spinner class="mat-accent"></mat-spinner>
    </button>
  }


  <button class="mat-accent" mat-raised-button data-e2e="error-reporting-modal-cancel" (click)="dialogRef.close(false)" [disabled]="isFormPending">{{'error_reporting.cancel' | translate}}</button>
</mat-dialog-actions>
